import { ActionGlyph } from '../../components/ActionGlyph'
import { useAppState } from '../../state/AppProvider'
import { AccountScaffold } from './AccountScaffold'

interface TicketOnboardingPageProps {
  navigate: (to: string) => void
}

export function TicketOnboardingPage({ navigate }: TicketOnboardingPageProps) {
  const state = useAppState()
  const hasTicket = state.tickets.some((ticket) => ticket.status === 'connected')

  return (
    <AccountScaffold
      eyebrow="Setup · Final step"
      title={hasTicket ? 'Ticket connected' : 'Bring your show with you'}
      intro={hasTicket
        ? 'Your connected show is ready for planning, check-in, and passport progress.'
        : 'Connect a ticket access code to unlock the complete show-day route.'}
      onBack={() => navigate('/auth/email-next-step')}
    >
      <section className="access-section" aria-labelledby="ticket-benefits-heading">
        <h2 id="ticket-benefits-heading">What connection adds</h2>
        <div className="settings-list">
          <div className="settings-link">
            <span className="settings-link__copy">
              <strong>Your show up front</strong>
              <span>Home, timing, city activity, and itinerary center on the connected stop.</span>
            </span>
          </div>
          <div className="settings-link">
            <span className="settings-link__copy">
              <strong>Show-day check-in</strong>
              <span>Eligible connected tickets can check in when the window opens.</span>
            </span>
          </div>
          <div className="settings-link">
            <span className="settings-link__copy">
              <strong>Passport progress</strong>
              <span>A completed check-in earns the stamp for that stop.</span>
            </span>
          </div>
        </div>
      </section>
      <div className="access-actions">
        <button className="access-primary" type="button" onClick={() => navigate(hasTicket ? '/home' : '/tickets/connect')}>
          {hasTicket ? 'Go to home' : 'Connect a ticket'}
          <ActionGlyph />
        </button>
        {!hasTicket ? (
          <button className="access-secondary" type="button" onClick={() => navigate('/home')}>
            Do this later
            <ActionGlyph />
          </button>
        ) : null}
      </div>
    </AccountScaffold>
  )
}
